/**
 * ============================================================
 * BOULEVARD STRIP — MOTEUR DE RÈGLES & LOGIQUE COMMERCIALE UNIFIÉ
 * Grille Officielle :
 * - Palier 1 (Dès 100 €) : Option A : +10,00 € Cashback / Option B : +15,00 € Vestiaire Privé
 * - Palier 2 (Dès 150 €) : Option A : +15,00 € Cashback / Option B : +20,00 € Vestiaire Privé
 * - Statut Exécutif (Dès 300 €) : Option A : +25,00 € Cashback / Option B : +50,00 € Vestiaire Privé
 * Synchronisation non-intrusive avec bsInitCartRewardModule (Tiroir Panier & Page /cart)
 * ============================================================
 */
(function(window, document) {
  'use strict';

  var TIERS = [
    {
      index: 0,
      name: 'Palier 1',
      minCents: 0,
      nextThresholdCents: 10000,
      badge: "DÈS 100 € D'ACHAT",
      barPercent: 33,
      cashbackCents: 1000,
      vestiaireCents: 1500,
      cardCashbackCents: 1000,
      cardVestiaireCents: 1500,
      vir: '10,00 €',
      cred: '15,00 €',
      label: "Dès 100 € d'achat"
    },
    {
      index: 1,
      name: 'Palier 1',
      minCents: 10000,
      nextThresholdCents: 15000,
      badge: 'PALIER 1 DÉBLOQUÉ',
      barPercent: 50,
      cashbackCents: 1000,
      vestiaireCents: 1500,
      cardCashbackCents: 1000,
      cardVestiaireCents: 1500,
      vir: '10,00 €',
      cred: '15,00 €',
      label: 'Palier 1 (100 EUR)'
    },
    {
      index: 2,
      name: 'Palier 2',
      minCents: 15000,
      nextThresholdCents: 30000,
      badge: 'PALIER 2 DÉBLOQUÉ',
      barPercent: 75,
      cashbackCents: 1500,
      vestiaireCents: 2000,
      cardCashbackCents: 1500,
      cardVestiaireCents: 2000,
      vir: '15,00 €',
      cred: '20,00 €',
      label: 'Palier 2 (150 EUR)'
    },
    {
      index: 3,
      name: 'Statut Exécutif',
      minCents: 30000,
      nextThresholdCents: null,
      badge: 'STATUT EXÉCUTIF DÉBLOQUÉ ★',
      barPercent: 100,
      cashbackCents: 2500,
      vestiaireCents: 5000,
      cardCashbackCents: 2500,
      cardVestiaireCents: 5000,
      vir: '25,00 €',
      cred: '50,00 €',
      label: 'Statut Exécutif (300 EUR+)'
    }
  ];

  function formatEur(cents) {
    var safeCents = (typeof cents === 'number' && !isNaN(cents)) ? Math.max(0, Math.round(cents)) : 0;
    var eur = (safeCents / 100).toFixed(2).replace('.', ',');
    return eur + ' €';
  }

  function parseEurToCents(str) {
    if (!str) return 0;
    var clean = String(str).replace(/[^0-9,.-]/g, '').replace(',', '.');
    var num = parseFloat(clean);
    return isNaN(num) ? 0 : Math.max(0, Math.round(num * 100));
  }

  function getTierByCents(cents) {
    var safeCents = (typeof cents === 'number' && !isNaN(cents)) ? cents : 0;
    if (safeCents >= 30000) return TIERS[3];
    if (safeCents >= 15000) return TIERS[2];
    if (safeCents >= 10000) return TIERS[1];
    return TIERS[0];
  }

  function computeCleanSubtotalCents(cart) {
    if (typeof cart === 'number' && !isNaN(cart)) {
      return Math.max(0, Math.round(cart));
    }
    if (!cart || typeof cart !== 'object') {
      return 0;
    }
    var baseTotal = (typeof cart.total_price === 'number' && !isNaN(cart.total_price))
      ? cart.total_price
      : 0;
    return Math.max(0, Math.round(baseTotal));
  }

  function getCartCents() {
    var boxes = document.querySelectorAll('[id="bsCartRewardModule"]');
    for (var i = 0; i < boxes.length; i++) {
      var attr = boxes[i].getAttribute('data-cart-total-cents');
      if (attr !== null && attr !== '') {
        var parsed = parseInt(attr, 10);
        if (!isNaN(parsed) && parsed >= 0) return parsed;
      }
    }
    if (window.bsCachedCart && typeof window.bsCachedCart.total_price === 'number') {
      return computeCleanSubtotalCents(window.bsCachedCart);
    }
    return 0;
  }

  function getSelectedMode() {
    if (window.bsUserExplicitCartChoice === 'vestiaire' || window.bsUserExplicitCartChoice === 'cashback') {
      return window.bsUserExplicitCartChoice;
    }
    try {
      var saved = sessionStorage.getItem('bs_selected_reward_mode') || sessionStorage.getItem('bs_pdp_reward_choice') || sessionStorage.getItem('bs_reward_mode');
      if (saved === 'vestiaire' || saved === 'cashback') return saved;
    } catch(e) {}
    var mod = document.getElementById('bsCartRewardModule');
    if (mod) {
      var dm = mod.getAttribute('data-selected-mode');
      if (dm === 'vestiaire' || dm === 'cashback') return dm;
    }
    return 'cashback';
  }

  function setSelectedMode(mode) {
    var valid = (mode === 'vestiaire') ? 'vestiaire' : 'cashback';
    window.bsUserExplicitCartChoice = valid;
    try {
      sessionStorage.setItem('bs_selected_reward_mode', valid);
      sessionStorage.setItem('bs_pdp_reward_choice', valid);
      sessionStorage.setItem('bs_reward_mode', valid);
      sessionStorage.setItem('bs_selected_dotation', valid === 'vestiaire' ? 'Crédit Vestiaire' : 'Cashback');
      localStorage.setItem('bs_selected_reward_mode', valid);
    } catch(e) {}
    return valid;
  }

  function syncDOMWithCart(cartInput) {
    if (cartInput && typeof cartInput === 'object' && typeof cartInput.total_price === 'number') {
      window.bsCachedCart = cartInput;
      var cents = computeCleanSubtotalCents(cartInput);
      var modules = document.querySelectorAll('[id="bsCartRewardModule"]');
      for (var i = 0; i < modules.length; i++) {
        modules[i].setAttribute('data-cart-total-cents', String(cents));
      }
    }
    if (typeof window.bsInitCartRewardModule === 'function') {
      window.bsInitCartRewardModule();
    }
  }

  window.bsSelectRewardMode = function(mode) {
    if (typeof window.bsSelectCartReward === 'function') {
      window.bsSelectCartReward(mode);
    } else {
      setSelectedMode(mode);
      syncDOMWithCart();
    }
  };
  window.bsSelectDotationMode = window.bsSelectRewardMode;

  window.bsSyncCart = function(optionalCart) {
    if (optionalCart && typeof optionalCart === 'object' && typeof optionalCart.total_price === 'number') {
      syncDOMWithCart(optionalCart);
      return;
    }
    if (typeof window.bsInitCartRewardModule === 'function') {
      window.bsInitCartRewardModule();
    }
  };

  function handleThemeCartEvent(e) {
    if (e && e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      syncDOMWithCart(e.detail.cart);
    } else if (typeof window.bsInitCartRewardModule === 'function') {
      window.bsInitCartRewardModule();
    }
  }

  document.addEventListener('cart:updated', handleThemeCartEvent);
  document.addEventListener('cart:refresh', handleThemeCartEvent);
  document.addEventListener('cart-drawer:updated', handleThemeCartEvent);
  document.addEventListener('product-ajax:added', handleThemeCartEvent);

  function attachCartObserver() {
    if (window._bsCartObserverAttached || !document.body) return;
    window._bsCartObserverAttached = true;
    var observer = new MutationObserver(function(mutations) {
      var shouldReinit = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || m.addedNodes.length === 0) continue;
        var t = m.target;
        if (t && (
          t.id === 'CartDrawer' ||
          (typeof t.id === 'string' && (t.id.indexOf('CartDrawerBody-') === 0 || t.id.indexOf('MainCart-') === 0)) ||
          (t.classList && (t.classList.contains('drawer__inner') || t.classList.contains('cart__items')))
        )) {
          shouldReinit = true;
          break;
        }
      }
      if (shouldReinit && typeof window.bsInitCartRewardModule === 'function') {
        window.bsInitCartRewardModule();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    attachCartObserver();
  } else {
    document.addEventListener('DOMContentLoaded', attachCartObserver);
  }

  window.bsGetSelectedAdvantage = function() {
    var mode = getSelectedMode();
    var cents = getCartCents();
    var tier = getTierByCents(cents);
    return mode === 'vestiaire'
      ? ('Option B · Vestiaire Privé · +' + tier.cred)
      : ('Option A · Cashback · +' + tier.vir);
  };

  window.bsRulesEngine = {
    getTierByCents: getTierByCents,
    computeCleanSubtotalCents: computeCleanSubtotalCents,
    getCartCents: getCartCents,
    formatEur: formatEur,
    parseEurToCents: parseEurToCents,
    getSelectedMode: getSelectedMode,
    setSelectedMode: setSelectedMode,
    syncDOMWithCart: syncDOMWithCart,
    TIERS: TIERS
  };
})(window, document);
